import React from "react";
import { Switch, Route, Redirect, withRouter } from "react-router-dom";
import Landing from "@view/landing/Landing";
import Register from "@view/register/Register";
import Dashboard from "@view/dashboard/Dashboard";
import PDPA from "@view/PDPA/PDPA";
import TermAndConditions from "@view/termAndConditions/TermAndConditions";
import WaiverAndIndemnity from "@view/waiverAndIndemnity/WaiverAndIndemnity";
import PrivacyPolicyPage from "@view/privacyPolicy/PrivacyPolicyPage";

const IndexRoute = withRouter(({ location }) => (
  <Switch key={location.pathname} location={location}>
    <Route exact path="/" component={Landing} key="Landing" />
    <Route path="/register/*" component={Register} key="Register" />
    <Redirect from="/register" to="/register/parent" />

    <Route path="/dashboard" component={Dashboard} key="Dashboard" />

    <Route path="/pdpa" component={PDPA} key="PDPA" />
    <Route
      path="/term-and-conditions"
      component={TermAndConditions}
      key="TermAndConditions"
    />
    <Route
      path="/waiver-and-indemnity"
      component={WaiverAndIndemnity}
      key="WaiverAndIndemnity"
    />
    <Route
      path="/privacy-policy"
      component={PrivacyPolicyPage}
      key="PrivacyPolicy"
    />

    <Redirect from="*" to="/" />
  </Switch>
));

export default IndexRoute;
